/**
 * Sets cursor to the end of the input field.
 *
 * @param event
 */
export function moveCursorToTheEnd(event) {
    event.currentTarget.setSelectionRange(event.currentTarget.value.length, event.currentTarget.value.length);
}
